import { getTransactionKind, TRANSACTION_KINDS } from "./transaction-types";

export const NOTIFICATION_SCOPE_PAYABLE = "payable";
export const NOTIFICATION_SCOPE_RECEIVABLE = "receivable";
export const NOTIFICATION_SCOPE_CARD_INVOICE = "card_invoice";

// Janela publicada ao servidor: o índice só carrega o que está por vencer.
export const SCHEDULE_WINDOW_DAYS = 45;

function toIsoDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 10);
}

function isSettled(transaction = {}) {
  return transaction.status === true || transaction.confirmed === true;
}

export function getTransactionScope(transaction = {}) {
  if (transaction.invoice_due_date) return NOTIFICATION_SCOPE_CARD_INVOICE;
  if (getTransactionKind(transaction) === TRANSACTION_KINDS.TRANSFER) return null;
  if (transaction.type === "income") return NOTIFICATION_SCOPE_RECEIVABLE;
  if (transaction.type === "expense") return NOTIFICATION_SCOPE_PAYABLE;
  return null;
}

function isWithinWindow(isoDate, referenceDate, windowDays) {
  const due = new Date(`${isoDate}T00:00:00Z`);
  const start = new Date(`${toIsoDate(referenceDate)}T00:00:00Z`);
  const diffDays = Math.round((due - start) / 86400000);
  return diffDays >= 0 && diffDays <= windowDays;
}

/**
 * Materializa o índice de vencimentos a partir dos dados já descriptografados.
 *
 * Publica apenas identificador, escopo e data — nunca descrição ou valor. Lançamentos
 * já liquidados e transferências ficam de fora.
 */
export function buildNotificationSchedules(transactions = [], options = {}) {
  const {
    scopes = [],
    referenceDate = new Date(),
    windowDays = SCHEDULE_WINDOW_DAYS,
  } = options;

  if (!scopes.length) return [];

  const allowed = new Set(scopes);
  const items = [];
  const seen = new Set();

  transactions.forEach((transaction) => {
    if (!transaction?.id || isSettled(transaction)) return;

    const scope = getTransactionScope(transaction);
    if (!scope || !allowed.has(scope)) return;

    const dueDate = toIsoDate(transaction.invoice_due_date || transaction.date);
    if (!dueDate || !isWithinWindow(dueDate, referenceDate, windowDays)) return;

    const sourceType = scope === NOTIFICATION_SCOPE_CARD_INVOICE ? "card_invoice" : "transaction";
    const key = `${sourceType}:${transaction.id}`;
    if (seen.has(key)) return;
    seen.add(key);

    items.push({
      source_type: sourceType,
      source_id: transaction.id,
      scope,
      due_date: dueDate,
    });
  });

  return items;
}
